import { uniqBy } from 'lodash/array';
import selectEvent from '%evp_ticket_frontend/js/redux/currentEvent/selectors/selectEvent';
import { openSnackbar, VARIANT_ERROR } from '%app/js/common/components/material/Snackbar';
import {
    GENERAL_ADMISSION_PURCHASE_STATUS_FREE,
    GENERAL_ADMISSION_PURCHASE_STATUS_RESERVED,
    GENERAL_ADMISSION_PURCHASE_STATUS_SOLD_OUT,
    OBJECT_TYPE_GENERAL_ADMISSION,
    SEAT_PURCHASE_STATUS_PURCHASED,
    SEAT_PURCHASE_STATUS_RESERVED,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import Translator from '%app/js/common/services/translator';
import selectCurrentOrder from '%evp_ticket_frontend/js/redux/currentOrder/selectors/selectCurrentOrder';
import setSeatsPurchaseStatus from './setSeatsPurchaseStatus';
import adjustGeneralAdmissionsUsedSeatsCount from './adjustGeneralAdmissionsUsedSeatsCount';
import seatingsClient from '../service/SeatingsClient';
import resolveUserPurchasedSeats from '../service/resolveUserPurchasedSeats';
import groupUsedSeatsByGeneralAdmission from '../service/groupUsedSeatsByGeneralAdmission';
import selectGeneralAdmissionByHash from '%paysera_seat_selection_integration/js/seatings/redux/components/orm/selectors/selectGeneralAdmissionByHash';
import setGeneralAdmissionsPurchaseStatus from '%paysera_seat_selection_integration/js/seatings/redux/components/orm/actions/setGeneralAdmissionsPurchaseStatus';

function initializeSeatings(subscriptionHash = null, options) {
    return async (dispatch, getState) => {
        const event = selectEvent(getState());
        const order = selectCurrentOrder(getState());
        if (!event || !order) {
            return;
        }
        const { user_id: userId } = order;
        try {
            for await (const seatings of seatingsClient.getSeatings(event.token, options)) {
                const { userSeats, remainingSeats } = resolveUserPurchasedSeats(seatings, userId, subscriptionHash);
                if (userSeats.length > 0) {
                    dispatch(setSeatsPurchaseStatus({
                        seats: userSeats,
                        status: SEAT_PURCHASE_STATUS_RESERVED,
                    }));
                }
                if (remainingSeats.length > 0) {
                    dispatch(setSeatsPurchaseStatus({
                        seats: remainingSeats,
                        status: SEAT_PURCHASE_STATUS_PURCHASED,
                    }));
                }
                const generalAdmissionUsedSeats = groupUsedSeatsByGeneralAdmission(seatings);
                if (Object.keys(generalAdmissionUsedSeats).length > 0) {
                    dispatch(adjustGeneralAdmissionsUsedSeatsCount(generalAdmissionUsedSeats));
                }

                const generalAdmissions = seatings.filter(seating => seating.type === OBJECT_TYPE_GENERAL_ADMISSION);

                uniqBy(generalAdmissions, 'hash').forEach((generalAdmission) => {
                    const { seatsTotal, seatsUsed } = selectGeneralAdmissionByHash(getState(), generalAdmission.hash);
                    let generalAdmissionStatus = GENERAL_ADMISSION_PURCHASE_STATUS_FREE;

                    const foundByHashAndUser = generalAdmissions.find(
                        ({ user, hash }) => userId === user && hash === generalAdmission.hash,
                    );

                    if (foundByHashAndUser !== undefined) {
                        generalAdmissionStatus = GENERAL_ADMISSION_PURCHASE_STATUS_RESERVED;
                    } else if (seatsTotal === seatsUsed) {
                        generalAdmissionStatus = GENERAL_ADMISSION_PURCHASE_STATUS_SOLD_OUT;
                    }

                    dispatch(setGeneralAdmissionsPurchaseStatus({
                        generalAdmissions: [generalAdmission],
                        status: generalAdmissionStatus,
                    }));
                });
            }
        } catch (error) {
            if (error.response && error.response.status < 500) {
                dispatch(openSnackbar({
                    variant: VARIANT_ERROR,
                    message: Translator.trans(error.response.data.error_description),
                }));
            } else {
                throw error;
            }
        }
    };
}

export default initializeSeatings;
